import React from 'react';

// Testo dell'assistente: **grassetto**, elenchi con "-" o "1.", etichette [F1][F2] come un solo numeretto "1,2" delle fonti
const Riga = ({ testo, numeri }) => testo.split(/(\*\*[^*]+\*\*|(?:\[F\d+\])+)/g).map((p, i) => {
  if (/^\*\*[^*]+\*\*$/.test(p)) return <strong key={i}>{p.slice(2, -2)}</strong>;
  if (/^(?:\[F\d+\])+$/.test(p)) {
    const n = [...new Set(p.match(/F\d+/g).map((t) => numeri[t]).filter(Boolean))].sort((x, y) => x - y);
    return n.length ? <sup key={i} className="mx-0.5 px-1 rounded bg-sky-100 text-sky-800 text-[10px] font-bold" data-testid={`assistente-cita-F${n[0]}`}>{n.join(',')}</sup> : null;
  }
  return <React.Fragment key={i}>{p}</React.Fragment>;
});

export const TestoRisposta = ({ testo, fonti, norma }) => {
  const numeri = Object.fromEntries((fonti || []).map((f, i) => [f.tag, i + 1]));
  const resto = testo.replace(/^\s*\[NORMA\]\s*/, '').replace(norma ? /^Nel vostro manuale non l'ho trovato:?\s*/i : /^$/, '');
  const pulito = resto.charAt(0).toUpperCase() + resto.slice(1);
  return (
    <div className="space-y-1.5 text-sm leading-relaxed text-gray-900">
      {pulito.split('\n').map((r, i) => {
        const punto = r.match(/^\s*(?:[-•*]|\d+[.)])\s+(.*)/);
        if (!r.trim()) return null;
        return punto
          ? <p key={i} className="pl-4 relative"><span className="absolute left-0 text-gray-400">•</span><Riga testo={punto[1]} numeri={numeri} /></p>
          : <p key={i}><Riga testo={r} numeri={numeri} /></p>;
      })}
    </div>
  );
};
